export default "__VITE_ASSET__33kSFcbZ__"